import React from 'react';
import ARROW from 'assets/img/play_arrow.svg';
import ARROW_BLUE from 'assets/img/play_arrow_blue.svg';
import { CustomIcon } from 'view/common';
import { ProviderProgressBar } from '../ProviderProgressBar';
import './style.scss';

export const AccessTypes = ({ isDarkTheme }) => (
  <div className="access_types">
    <div className="access_types_header">
      <h2 className="access_types_subtitle">Access Types</h2>
      <span>
        <CustomIcon
          src={isDarkTheme ? ARROW_BLUE : ARROW}
          width="8px"
          height="10px"
          rotate="270"
        />View all
      </span>
    </div>
    <ProviderProgressBar title="Technology A" percent={25} />
    <ProviderProgressBar title="Technology B" percent={45} />
    <ProviderProgressBar title="Technology C" percent={50} />
    <ProviderProgressBar title="Technology D" percent={85} />
    <ProviderProgressBar title="Technology E" percent={5} />
  </div>
);



// WEBPACK FOOTER //
// ./src/view/screens/Project/components/AccessTypes/index.js